import { Icon }      from "@chakra-ui/react";
import { IconProps } from "@chakra-ui/react";

const CloseIcon = (props: IconProps) => {
    return (
		<Icon {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#555">
				<path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/>
			</svg>
		</Icon>
    )
}

export default CloseIcon;